import crypto from 'crypto';

export type Alignment = { naceCode: string; alignmentPct: number; version: string; signature: string };

export async function getAlignment(naceCode: string): Promise<Alignment> {
  const pct = Math.max(0, Math.min(100, Math.round((Math.random()*60)+20)));
  const version = 'EU-TAXO-1.2';
  const payload = { naceCode, alignmentPct: pct, version };
  const signature = signOracleResponse(payload);
  return { ...payload, signature };
}

export function signOracleResponse(payload: object): string {
  // JWS mock signature (sha256 over JSON)
  const hash = crypto.createHash('sha256').update(JSON.stringify(payload)).digest('hex');
  return `demo-jws.${hash}`;
}



















